import React, { useState } from "react";
import { Button } from "semantic-ui-react";
import { BasicModal } from "../../../../components/Shared";
import { useAuth } from "../../../../hooks";
import { TeacherList } from "../../../../components/Admin/TeacherCmp";
import { TeacherForm } from "../../../../components/Admin/TeacherCmp/TeacherForm";
import { useTranslation } from "react-i18next";
import "./Page_Institution_Teacher.scss";

export function Page_Institution_Teacher() {
  const { user, accessToken } = useAuth();
  const { t } = useTranslation("institutions");

  // Estados para los modales y recargas

  const [showModalDocente, setShowModalDocente] = useState(false);
  const onOpenCloseModalDocente = () =>
    setShowModalDocente((prevState) => !prevState);
  const [reloadDocente, setReloadDocente] = useState(false);
  const onReloadDocente = () => setReloadDocente((prevState) => !prevState);
  const [reload, setReload] = useState(false); // Estado para forzar la recarga de la lista de escenas
  const onReload = () => setReload((prevState) => !prevState); // Función para forzar la recarga de las escenas

  return (
    <div className="institution-profile-page">
      {/* Sección con botones */}
      <div>
        <Button className="button-teacher" onClick={onOpenCloseModalDocente}>
          {t("pages.newTeacherButton")}
        </Button>
      </div>
      <div>
        {" "}
        <h1>{t("pages.teacherListTitle")}</h1>
        <TeacherList
          user={user}
          accessToken={accessToken}
          reload={reload}
          onReload={onReload}
        />
      </div>

      {/* Modales */}
      <BasicModal
        show={showModalDocente}
        close={onOpenCloseModalDocente}
        title={t("pages.createTeacherTitle")}
      >
        <TeacherForm
          user={user}
          show={showModalDocente}
          onClose={onOpenCloseModalDocente}
          reloadDocente={reloadDocente}
          onReload={onReloadDocente}
        />
      </BasicModal>
    </div>
  );
}
